import { render, staticRenderFns } from "./NumberPeople.vue?vue&type=template&id=0cbdc88e&scoped=true&"
import script from "./NumberPeople.vue?vue&type=script&lang=js&"
export * from "./NumberPeople.vue?vue&type=script&lang=js&"
import style0 from "./NumberPeople.vue?vue&type=style&index=0&id=0cbdc88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdc88e",
  null
  
)

export default component.exports